'use client'
import SignupForm from "@/features/signup/templates"
import { usePageMeta } from "@aw/lib"
/**
 * `POST /register` answers `204 No Content`, so the new organization's uid is not in the
 * response — it has to be looked up afterwards. `/welcome` already does exactly that
 * (resolves the org, waits for the fetch, then forwards to its dashboard), and is where
 * this form already sends an already-signed-in user, so route through it rather than
 * duplicating the lookup.
 *
 * Reading the uid off the register response is what produced `/o/undefined/dashboard`.
 */
export const redirectionHandler = () => {
    window.location.href = `${process.env.NEXT_PUBLIC_ORG_URL}/welcome`
}

const Page = () => {
    usePageMeta({ title: "Sign Up | Olamee" })
    return <SignupForm redirectionHandler={redirectionHandler} />

}

export default Page
